export const environment = {
    local: false,
    production: true,
    sentry: {
        activate: true,
        sampleRate: 0.01,
    },
}
